import { CoordinatesModel } from '@src/shared/src/models';
import { Marker, useMap } from '@vis.gl/react-google-maps';
import * as React from 'react';

type Props = {
  depLat: number;
  depLng: number;
  arrLat: number;
  arrLng: number;
};

const SearchMapPolyline: React.FC<Props> = ({ depLat, depLng, arrLat, arrLng }) => {
  const map = useMap();

  const depCoord = new CoordinatesModel(depLat, depLng);
  const arrCoord = new CoordinatesModel(arrLat, arrLng);

  if (map?.getProjection() && depCoord.exists && arrCoord.exists) {
    const pos1 = new google.maps.LatLng(depCoord.lat, depCoord.lng);
    const pos2 = new google.maps.LatLng(arrCoord.lat, arrCoord.lng);
    const p1 = map.getProjection().fromLatLngToPoint(pos1);
    const p2 = map.getProjection().fromLatLngToPoint(pos2);
    const e = new google.maps.Point(p2.x - p1.x, p2.y - p1.y);
    const m = new google.maps.Point(e.x / 2, e.y / 2);
    const o = new google.maps.Point(-e.y, e.x);
    const c = new google.maps.Point(m.x + 0.25 * o.x, m.y + 0.25 * o.y);
    const pathDef = 'M 0,0 ' + 'q ' + c.x + ',' + c.y + ' ' + e.x + ',' + e.y;
    const scale = 1 / Math.pow(2, -map.getZoom());
    const icon = {
      path: pathDef,
      scale,
      strokeWeight: 2,
      strokeColor: '#D6DEE6',
      fillColor: 'none',
    };
    return <Marker position={depCoord} icon={icon} />;
  }
};

export default SearchMapPolyline;
